import { $Q } from '../utils/query-selector';
import { dataToggle } from '../utils/toggle-dataset';
import validEmail from '../utils/valid-email';
import validPhone from '../utils/valid-phone';

const contactForm = $Q('#contact_form');

const onSubmit = (event) => {
  event.preventDefault();

  const email = $Q('#email');
  const phone = $Q('#phone');
  const formEmailError = $Q('.form-email__error');
  const formPhoneError = $Q('.form-phone__error');
  const isEmailValid = validEmail(email.value);

  if (!isEmailValid) {
    formEmailError.setAttribute('data-active', true);
  } else {
    formEmailError.setAttribute('data-active', false);
  }

  // Validate phone
  const isPhoneValid = validPhone(phone.value);
  if (!isPhoneValid) {
    formPhoneError.setAttribute('data-active', true);
  } else {
    formPhoneError.setAttribute('data-active', false);
  }

  // If all validations pass, submit the form
  if (isEmailValid && isPhoneValid) {
    contactForm.submit();

    window.location.href = 'https://anatae.fr/pages/contact-success'
  }
};

const initForm = () => {
  const sendForm = $Q(".contact-form__submit");
  if (!contactForm) return;

  sendForm.addEventListener('click', onSubmit);
};

initForm(); 